import { IDataSource } from "../Data/DataSource";
import { ObjectHelper } from "../Helpers/ObjectHelper";
import { IJNativeEvent } from "../JNative";
import { PropertyChange } from "../PropertyChange";
import { Property } from "../RadObject";
import { Evaluator } from "../Server/DotNet/SeriouslyRAD.Framework/Evaluation/Evaluator";
import { EvaluatorPropertyValues, IEvaluator } from "../Server/DotNet/SeriouslyRAD.Framework/Evaluation/IEvaluator";
import { IContainerControl } from "../Ui/Controls/ContainerControl";
import { Control, IControl } from "../Ui/Controls/Control";
import { NAMESPACE } from "./_Namespace";

export type HasVisibleChildrenEvaluatorPropertyValues =
    EvaluatorPropertyValues
    & {
    };

export type HasVisibleChildrenEvaluatorProperties = {
    [name in keyof HasVisibleChildrenEvaluatorPropertyValues]: Property<HasVisibleChildrenEvaluatorPropertyValues[name]>
};

export interface IHasVisibleChildrenEvaluator extends IEvaluator, HasVisibleChildrenEvaluatorProperties
{
}

export class HasVisibleChildrenEvaluator extends Evaluator<HasVisibleChildrenEvaluatorPropertyValues> implements IHasVisibleChildrenEvaluator
{
    public static override classNamespace = NAMESPACE + "HasVisibleChildrenEvaluator";
    public static override className = "HasVisibleChildrenEvaluator";

    // #region Overrides

    protected override _contextChanged(change: PropertyChange<IControl | IDataSource>)
    {
        if (change.originalValue instanceof Control)
            change.originalValue.off("isVisibleChanged", { self: this }, this.onChildVisibilityChanged);

        if (change.currentValue instanceof Control)
            change.currentValue.on("isVisibleChanged", { self: this }, this.onChildVisibilityChanged);

        super._contextChanged(change);
    }

    public override evaluate()
    {
        const
            context = this.context.get(),
            value =
                (context && ObjectHelper.isAssignableTo<IContainerControl>(context, "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ContainerControl.ContainerControl"))
                    ? context.controlsGet().some(item => item.isVisible?.get())
                    : true;

        this.value.set(value);

        return value;
    }

    // #endregion

    // #region Event Handlers

    protected onChildVisibilityChanged(evt: IJNativeEvent)
    {
        const
            self = evt.data.self as this;

        self.evaluate();
    }

    // #endregion
}

